import React from "react";
import VirtualHendiInterface from "./components/VirtualHendiInterface"

function App() {
  return <VirtualHendiInterface/>;
}

export default App;
